import Authentication from 'components/images/apidetails-snapshot.jpg';
import * as React from 'react';
export default {
  Authentication,
  React
};